import { OracleQuantifyChart } from '@modules/oracle/components/OracleConversationMarkdown/OracleQuantifyChart';
import { OracleQuantifyProvider } from '@modules/oracle/components/OracleQuantifyProvider';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { Paper } from '@mui/material';
import React from 'react';
import { ExtraProps } from 'react-markdown';

type OracleQuantifyChartWrapperProps = React.ClassAttributes<HTMLElement> &
  React.HTMLAttributes<HTMLElement> &
  ExtraProps & { promptID: string };

export const OracleQuantifyChartWrapper = React.memo(
  ({ node, promptID }: OracleQuantifyChartWrapperProps) => {
    const tokenV2ID = node?.properties?.['id']
      ? String(node?.properties?.['id'])
      : '';

    const assistantResponseEqlToken = useOracleSearchStore(
      ({ data }) => data.promptByID?.[promptID].eqlByTokenV2ID?.[tokenV2ID],
    );

    if (!assistantResponseEqlToken) {
      return null;
    }

    return (
      <OracleQuantifyProvider>
        <Paper sx={{ p: 2, borderRadius: 3 }} elevation={0}>
          <OracleQuantifyChart
            promptID={promptID}
            tokenV2ID={tokenV2ID}
            assistantResponseEqlToken={assistantResponseEqlToken}
          />
        </Paper>
      </OracleQuantifyProvider>
    );
  },
);
